// src/pages/Home.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo from '../images/shamrock_services_logo_invert.png';
import CredentialsBanner from '../components/CredentialsBanner';

const HomeWrapper = styled.div`
  text-align: center;
`;

const Hero = styled.div`
  background-color: #0C2340;
  color: #AE9142;
  padding: 60px 0;
`;

const Title = styled.h1`
  font-size: 48px;
  margin-bottom: 20px;
`;

const Subtitle = styled.p`
  font-size: 24px;
  margin-bottom: 30px;
`;

const CTAButton = styled(Link)`
  background-color: #006331;
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  font-size: 18px;
  border-radius: 5px;
  &:hover {
    background-color: #00843D;
  }
`;

const Home = () => {

  return (
    <HomeWrapper>
      <Hero>
        <img src={logo} width={200} height={200} alt='Shamrock Services Logo' />
        <Title>Welcome to Shamrock Services</Title>
        <Subtitle>Our mission is to provide honest and reliable service to the community we love!
          Whether you're needing home repairs or have a passion project to bring to life, we're eager to help in any way we can! </Subtitle>
        <CTAButton to="/contact">Get a Quote</CTAButton>
      </Hero>
      {/* Add more sections as needed */}

      <CredentialsBanner />

    </HomeWrapper>
  );
};

export default Home;